const STORAGE_KEY_PREFIX = 'paddiq:workspace-guide-dismissed';

function storageKey(userId: string, teamId: string) {
  return `${STORAGE_KEY_PREFIX}:${userId}:${teamId}`;
}

export function readDismissedWorkspaceGuidePath(userId: string, teamId: string) {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(storageKey(userId, teamId));
}

export function writeDismissedWorkspaceGuidePath(userId: string, teamId: string, guidePath: string) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(storageKey(userId, teamId), guidePath);
}

export function clearDismissedWorkspaceGuidePath(userId: string, teamId: string) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(storageKey(userId, teamId));
}
